// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetEnrollmentByExternalIdRequestModel {
    static getAttributeTypeMap() {
        return GetEnrollmentByExternalIdRequestModel.attributeTypeMap;
    }
}
GetEnrollmentByExternalIdRequestModel.discriminator = undefined;
GetEnrollmentByExternalIdRequestModel.additionalProperties = false;
GetEnrollmentByExternalIdRequestModel.attributeTypeMap = [
    {
        "name": "externalId",
        "baseName": "externalId",
        "type": "string"
    },
    {
        "name": "accountExternalIdType",
        "baseName": "accountExternalIdType",
        "type": "AccountExternalIdType"
    },
];
//# sourceMappingURL=getEnrollmentByExternalIdRequestModel.js.map